export { default } from "./diagram1.component";
